import { Book02Icon, Layers01Icon, PaintBrush01Icon, QuillWrite02Icon, RulerIcon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import {
  Avatar,
  CardMedia,
  Divider,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Stack,
  Typography,
} from '@mui/material';
import { green } from '@mui/material/colors';
import { useFetchQuoteQuery } from '../organizations/api/quoteApi';
import useOrganizations from '../organizations/useOrganizations';
import { products, finishing, materials, dimentions } from './constants';
import pluralize from 'pluralize';
import { Content } from '@/types';

const Mydata = () => {
  const { currentOrganization } = useOrganizations();
  const { quoteId } = useParams();

  const { data } = useFetchQuoteQuery({
    organizationId: currentOrganization?.id ?? '',
    quoteId: quoteId ?? '',
  });

  const product = useMemo(() => {
    return Object.values(products).find((p) => p.id === data?.product);
  }, [data?.product]);

  const finish = useMemo(() => {
    return Object.values(finishing).find(
      (p) => p.id === (data?.finishing as unknown as string)
    );
  }, [data?.finishing]);

  const material = useMemo(() => {
    return Object.values(materials).find(
      (p) => p.id === (data?.material as unknown as string)
    );
  }, [data?.material]);

  const dimention = useMemo(() => {
    return Object.values(dimentions).find(
      (p) => p.id === (data?.dimention as unknown as string)
    );
  }, [data?.dimention]);

  const design = useMemo(() => {
    switch (data?.design) {
      case 'yes':
        return 'Si, ya tiene el diseño';
      case 'changes':
        return 'Si, ya tiene diseño, pero necesita cambios';
      default:
        return 'No tiene diseño, necesitaría sus servicios';
    }
  }, [data?.design]);

  return (
    <Stack padding={3}>
      <Stack spacing={2}>
        <Typography variant="h4">Contacto</Typography>
        <Stack>
          <Typography variant="overline">Nombre:</Typography>
          <Typography variant="body1">{data?.contact.name}</Typography>
        </Stack>
        <Stack direction="row" spacing={2}>
          <Stack flex={1}>
            <Typography variant="overline">Teléfono:</Typography>
            <Typography variant="body1">{data?.contact.phone}</Typography>
          </Stack>
          <Stack flex={1}>
            <Typography variant="overline">Correo:</Typography>
            <Typography variant="body1">{data?.contact.email}</Typography>
          </Stack>
        </Stack>
        <Stack>
          <Typography variant="overline">Comentarios:</Typography>
          <Typography variant="body1">{data?.contact.message}</Typography>
        </Stack>
        <Divider>Productos:</Divider>

        {data?.design ? (
          <Stack spacing={2}>
            <List>
              <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{ backgroundColor: green[500] }}>
                    <HugeiconsIcon icon={Book02Icon} />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Producto"
                  secondary={`${data?.quantity} ${pluralize(
                    product?.label ?? '',
                    data?.quantity
                  )}`}
                />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{ backgroundColor: green[500] }}>
                    <HugeiconsIcon icon={PaintBrush01Icon} />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary="Acabados" secondary={finish?.label} />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{ backgroundColor: green[500] }}>
                    <HugeiconsIcon icon={Layers01Icon} />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary="Material" secondary={material?.label} />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{ backgroundColor: green[500] }}>
                    <HugeiconsIcon icon={RulerIcon} />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText
                  primary="Dimensión"
                  secondary={dimention?.label}
                />
              </ListItem>
              <Divider />
              <ListItem>
                <ListItemAvatar>
                  <Avatar sx={{ backgroundColor: green[500] }}>
                    <HugeiconsIcon icon={QuillWrite02Icon} />
                  </Avatar>
                </ListItemAvatar>
                <ListItemText primary="Diseño" secondary={design} />
              </ListItem>
            </List>
          </Stack>
        ) : (
          <Stack spacing={3} padding={3}>
            {data?.products?.map((product: Content) => (
              <Stack key={product.id} direction={'row'} spacing={2}>
                <CardMedia
                  className="product"
                  component={'img'}
                  title={product.title}
                  image={product.images[0]}
                  sx={{
                    maxWidth: '125px',
                    height: '125px',
                    borderRadius: '8px',
                  }}
                />
                <Stack flex={1} height={'100%'} spacing={1}>
                  <Typography
                    variant="h2"
                    fontSize={'18px'}
                    sx={{ display: 'flex', justifyContent: 'flex-start' }}
                  >
                    {product.title}
                  </Typography>
                  {(Object.entries(product.settings) ?? []).map(
                    ([settingTitle, answers]) => (
                      <Stack
                        key={settingTitle}
                        direction={'row'}
                        spacing={1}
                        alignItems={'center'}
                      >
                        <Typography variant="h3" fontSize={'14px'}>
                          {`${settingTitle}: `}
                        </Typography>
                        {answers.map((answer) => (
                          <Typography
                            variant="body1"
                            key={answer}
                            fontSize={'14px'}
                          >
                            {answer}
                          </Typography>
                        ))}
                      </Stack>
                    )
                  )}
                </Stack>
              </Stack>
            ))}
          </Stack>
        )}
      </Stack>
    </Stack>
  );
};

export default Mydata;
